import React from 'react'
import styles from './app.styles'
import injectSheet from 'react-jss'
import { UserProvider, UserInspector } from 'pobble-components/dist/pobble-user'
import EnvironmentLine from 'pobble-components/dist/environment-line'
import Header from 'pobble-components/dist/pobble-header'
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom'
import Feed from '../pages/feed/feed'
import { ToastContainer } from 'pobble-components/dist/toast'
import Work from '../pages/work/work'
import { ConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import PageNotFound from 'pobble-components/dist/page-not-found'
import { SubscriptionProvider } from 'pobble-components/dist/subscriptions'
import { ErrorBoundary } from 'pobble-components/dist/error-boundary'

const APP_PATH = process.env.REACT_APP_PATH || '/'

const App = ({ classes, me, meError }) => {
  return (
    <UserProvider
      fetchMe={() => (me ? Promise.resolve(me) : Promise.reject(meError))}>
      <SubscriptionProvider>
        <EnvironmentLine />
        <Router basename={APP_PATH}>
          <Header activePage="actions" />
          <Switch>
            <ErrorBoundary>
              <UserInspector schoolRequired>
                <div className={classes.appHolder}>
                  <Switch>
                    <Route exact path={['/', '/upload']} component={Feed} />
                    <Route exact path="/work/:id" component={Work} />
                    <Route component={PageNotFound} />
                  </Switch>
                </div>
              </UserInspector>
            </ErrorBoundary>
          </Switch>
        </Router>
        <ToastContainer />
        <ConfirmationDialog />
      </SubscriptionProvider>
    </UserProvider>
  )
}

export default injectSheet(styles)(App)
